const actions = {
  async listQuotation(context, payload) {
    try {
      const response = await this.$api.call(
        "finops_invoice_detail_quote_list.list",
        payload,
      );
      if (response.data === null) {
        response.data = [];
      }
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationInvoiceDetailQuotationList", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationInvoiceDetailQuotationList", responseData);
      }

      context.commit("mutationInvoiceDetailQuotationListMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationInvoiceDetailQuotationList", []);
      context.commit("mutationInvoiceDetailQuotationListMeta", {});

      throw error;
    }
  },
};

export default actions;
